import { createI18n } from 'vue-i18n';

import en from './locales/en.json';
import fil from './locales/fil.json';
import th from './locales/th.json';
import es from './locales/es.json';

const messages = {
  en,
  fil,
  th,
  es,
};

const languageCode = localStorage.getItem('_language-code') || 'en';

const i18n = createI18n({
  locale: languageCode,
  fallbackLocale: languageCode,
  messages,
});

document.documentElement.lang = languageCode;

export default i18n;
